import questionReader from '../../store/readHelpers/QuestionReader';
import assessmentReader from '../../store/readHelpers/AssessmentReader';

const modalsContainerSelector = {
    selectShouldRenderOneWayNavigationModals(questionId) {
        const question = assessmentReader.getQuestion(questionId);
        return questionReader.shouldCommitAnswerTimestamp(question);
    },

    selectProps(state) {
        const { currentlyShown } = state;

        return {
            shouldRenderOneWayNavigationModals: this.selectShouldRenderOneWayNavigationModals(currentlyShown.questionId),
        };
    },
};

export default modalsContainerSelector;
